module.exports = {
	//basePath: '/projects/croquet/build/public/',
	basePath: '/',
	title: 'My App',
	description: 'A simple react application boilerplate'
}
